import { render, staticRenderFns } from "./SurfaceLayer.vue?vue&type=template&id=6a556d87&lang=pug"
import script from "./SurfaceLayer.vue?vue&type=script&lang=ts"
export * from "./SurfaceLayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports